// extracted by mini-css-extract-plugin
export default {"container":"EventContent_container__kr6Lv","barContainer":"EventContent_barContainer__KpkAL"};